import React, { useEffect, useRef } from "react";
import { useState } from "react";
import Badge from "../layout/Badge";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Loader from "../layout/Loader";
import fileDownload from "js-file-download";
import { createDealerOrderAction } from "../../redux/actions/OrderAction";
import { ListDealerAction } from "../../redux/actions/DealerAction";
import { getProductionData } from "./functions/OrderFunctions";
//MUI Dropdown Action
import ContentCutIcon from "@mui/icons-material/ContentCut";
import AddIcon from "@mui/icons-material/Add";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import { NotificationBadge } from "./ui/NotificationBadge";
import OrderOverviewUI from "./OrderComp/tables/OrderOverviewUI";
import { toggleFullScreen } from "../layout/functions/layout";
import { productTypeOptions } from "./functions/ComponentOptions";
import InputTableHeader from "./reusables/InputTableHeader";
import TableInputs from "./reusables/TableInputs";
import CustomKeyboard from "./functions/CustomKeyboard";
import { fetchSettingsAction } from "../../redux/actions/UserSettingsActions";
import {
  fetchCalculations,
  getAllInventoryItems,
  getFabricItems,
  getInvItemsByCat,
  getLiftStyleItems,
} from "../../redux/actions/InventoryAction";
import { recalculateOrders } from "./reusables/RecalculateOrder";
import OrderDetailsForm from "./orderForm/OrderDetailsForm";
import InputSettingsDropdown from "./orderForm/InputSettings";
import MaterialOrdersTable from "./reusables/MaterialTable";
import { fetchMatrixByProductType } from "../../redux/actions/MatrixAction";
import { getProductTypesAction } from "../../redux/actions/ProductTypeactions";
import { useSnackbarNotification } from "./reusables/UseSnackBarNotification";
import { Alert, Box, Button, CircularProgress } from "@mui/material";
import {
  checkHeadrailPricing,
  checkProductRate,
  getSelectedDealer,
} from "./functions/HelperFunctions";
import PricingModal from "./ui/PriceNotAvailableModal";
import AIImgToOrderButton from "./orderForm/ImageToOrderButton";

const OrderCreate = ({ nav }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userSignIn);
  const { userInfo } = userLogin;
  const listDealer = useSelector((state) => state.listDealer);
  const { loading: loadingClient, dealer, success } = listDealer;
  const createOrder = useSelector((state) => state.orderDealerCreate);

  const inventoryItems = useSelector((state) => state.getInvItemsByCat);
  const { data: inventoryData } = inventoryItems;
  const items = inventoryData?.[0]?.items || [];
  const fabricItemsState = useSelector((state) => state.fabricItems);
  const {
    loading: fabricLoading,
    error: fabricError,
    fabrics,
  } = fabricItemsState;
  const Fabrics = fabrics?.[0]?.items || [];
  const { liftStyleItems } = useSelector((state) => state.liftSyleItems);
  const liftStyleCategory = liftStyleItems?.find(
    (item) => item.category === "Lift_hardware"
  );
  const motorCategory = liftStyleItems?.find(
    (item) => item.category === "Motor"
  );

  const LiftStyle = liftStyleCategory?.items || [];
  const Motor = motorCategory?.items || [];

  const createInvItem = useSelector((state) => state.createInvItemReducer);
  const { success: inventoryCreateSuccess } = createInvItem;
  const {
    loading: loadingCreateOrder,
    data,
    success: successOrder,
  } = createOrder;
  const matrixState = useSelector((state) => state.matrix);
  const { loading, matrix, error } = matrixState;

  const [showCustomFabricModal, setShowCustomFabricModal] = useState(false);
  const [showCustomLiftStyleModal, setShowCustomLiftStyleModal] =
    useState(false);
  const { showSnackbar, SnackbarComponent } = useSnackbarNotification();

  const [errToggle, setErrToggle] = useState({});
  // const [dropdownToggle, setDropdownToggle] = useState(null);

  const [orderDetails, setOrderDetails] = useState({
    dealerName: "",
    productTag: "",
    productType: "",
    productMaterial: "",
    headrail: "",
    liftStyle: "",
    orderRemark: "",
  });
  const [orderFactor, setOrderFactor] = useState(0);
  const [customCost, setCustomCost] = useState(0);
  const [showAddMaterialModal, setShowAddMaterialModal] = useState(false);
  const [activeRowIndex, setActiveRowIndex] = useState(null);
  const [insertion, setInsertion] = useState({ val: null, trigger: false });

  const settings = useSelector((state) => state.userSettings);
  const { settings: settingsData } = settings;
  const [order, setOrder] = useState([]);

  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [sleeveOption, setSleeveOption] = useState("");

  //keyboard states and refs
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [focusedIndex, setFocusedIndex] = useState(null);
  const { calculations } = useSelector((state) => state.inventoryCalculation);
  const [deduction, setDeduction] = useState({ val: null, trigger: false });
  const [addition, setAddition] = useState({ val: null, trigger: false });

  const [showAdditionInput, setShowAdditionInput] = useState(false);
  const [showDeductionInput, setShowDeductionInput] = useState(false);
  const [selectedMaterialId, setSelectedMaterialId] = useState("");
  const [category, setCategory] = useState("");
  const [materialOrders, setMaterialOrders] = useState([
    {
      category: "",
      material: "",
      customCost: "",
      quantity: 1,
      sellingPrice: 0,
      discountRate: 0,
    },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const productTypesList = useSelector((state) => state.productTypes);
  const { productTypes } = productTypesList;

  const inputRefs = useRef([]);
  const tableContainerRef = useRef(null);

  useEffect(() => {
    if (settingsData) {
      const initialOrder = {
        width: "",
        height: "",
        factor: 0,
        liftStyle: "",
      };

      if (settingsData.showControl) {
        initialOrder.control = "right";
      }

      if (settingsData.showLocation) {
        initialOrder.location = "";
      }

      if (settingsData.showMountLift) {
        initialOrder.lift = "corded";
      }

      if (settingsData.showRemark) {
        initialOrder.remark = "";
      }
      if (settingsData.showTile) {
        initialOrder.tile = "";
      }

      setOrder([initialOrder]);
    }
  }, [settingsData]);

  useEffect(() => {
    dispatch(fetchSettingsAction(userInfo.token));
    dispatch(getProductTypesAction(userInfo.token));
  }, [dispatch]);

  const headrailConfig = items?.find(
    (item) => item.id === orderDetails?.headrail
  );

  useEffect(() => {
    if (orderDetails.productType && headrailConfig) {
      dispatch(
        fetchCalculations(
          orderDetails.productType,
          headrailConfig?.id,
          userInfo.token
        )
      );
    }
  }, [userInfo.token, dispatch, orderDetails.productType, headrailConfig]);

  useEffect(() => {
    const handleResize = () => {
      if (window.matchMedia("(max-width: 1000px)").matches) {
        setIsReadOnly(true);
        setIsKeyboardVisible(true);
      } else {
        setIsReadOnly(false);
        setIsKeyboardVisible(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleSettingsClick = () => {
    setShowSettingsModal(true);
  };

  const handleCloseModal = () => {
    setShowSettingsModal(false);
  };
  const handleInputChange = (index, field, value) => {
    // Create a shallow copy of the order array
    const updatedOrder = [...order];

    // Get the current row
    const currentRow = updatedOrder[index];

    updatedOrder[index] = { ...currentRow, [field]: value };

    setOrder(updatedOrder);

    const lastRow = updatedOrder[updatedOrder.length - 1];
    const isLastRowFilled =
      lastRow.width && lastRow.height && lastRow.liftStyle;

    // Add an empty row if the last row is filled

    if (isLastRowFilled) {
      updatedOrder.push({
        width: "",
        height: "",
        control: "",
        lift: "",
        liftStyle: lastRow.liftStyle,
        mount: "",
        remark: "",
        location: "",
        tile: "",
        deduction: "",
        addition: "",
      });

      setOrder(updatedOrder);
    }
  };

  //keyboard functions
  const handleKeyPress = (key) => {
    if (focusedIndex !== null) {
      const { row, field } = focusedIndex;
      const currentValue = order[row][field];

      const keyString = String(key);

      if (keyString.includes("/")) {
        const parts = currentValue.split(" ");
        if (parts.length > 1) {
          parts[parts.length - 1] = keyString;
        } else {
          parts.push(keyString);
        }
        const newValue = parts.join(" ");
        handleInputChange(row, field, newValue);
      } else {
        const newValue = currentValue + keyString;
        handleInputChange(row, field, newValue);
      }
    }
  };

  const handleNext = () => {
    if (focusedIndex !== null) {
      const { row, field } = focusedIndex;
      if (field === "width") {
        setFocusedIndex({ row, field: "height" });
      } else if (field === "height" && row < order.length - 1) {
        setFocusedIndex({ row: row + 1, field: "width" });
      }
    }
  };

  const handlePrevious = () => {
    if (focusedIndex !== null) {
      const { row, field } = focusedIndex;
      if (field === "height" && row > 0) {
        setFocusedIndex({ row: row - 1, field: "width" });
      } else if (field === "width") {
        setFocusedIndex({ row, field: "height" });
      }
    }
  };

  const handleEnter = () => {
    if (focusedIndex !== null) {
      const { row } = focusedIndex;
      if (row < order.length - 1) {
        setFocusedIndex({ row: row + 1, field: "width" });
      } else {
        setOrder([
          ...order,
          { width: "", height: "", sqft: 0, remark: "", location: "" },
        ]);
        setFocusedIndex({ row: row + 1, field: "width" });
      }
    }
  };

  const handleClear = () => {
    if (focusedIndex !== null) {
      const { row, field } = focusedIndex;
      handleInputChange(row, field, "");
    }
  };
  const handleChange = async (e) => {
    const { name, value } = e.target;

    setOrderDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));

    if (name === "productType" && value === "Materials") return;

    const dealerInfo = orderDetails.dealerName.split("_");
    const dealerId = dealerInfo[1];
    const selectedDealer = getSelectedDealer(dealer, dealerId);

    if (name === "productType" || name === "headrail") {
      if (name === "productType" && value !== "") {
        const productType = value;

        if (!selectedDealer) {
          showSnackbar(
            "Dealer not found. Please select a valid dealer or refresh the page.",
            "error"
          );
          return;
        }

        const validRate = checkProductRate(selectedDealer, productType);
        if (!validRate) {
          showSnackbar(
            `Pricing is missing or invalid for the selected product type (${productType}). Please update the product rates to proceed.`,
            "error"
          );
          setIsModalOpen(true);
          return;
        }
      }

      if (name === "headrail" && orderDetails.productType !== "") {
        const headrailId = value;
        const productType = orderDetails.productType;

        const pricingExists = checkHeadrailPricing(
          selectedDealer,
          headrailId,
          productType
        );

        if (!pricingExists) {
          showSnackbar(
            `Pricing is missing for the selected product type (${productType}) and headrail. Please add pricing before submitting.`,
            "error"
          );
          setIsModalOpen(true);
          return;
        }
      }
    }
  };

  const handleCloseKeyboard = () => {
    setIsKeyboardVisible(false);
  };

  const addRow = (index) => {
    const newOrder = [...order];
    newOrder.splice(index + 1, 0, {
      width: "",
      height: "",
      factor: 0,
      liftStyle: "",
      location: "",
      remark: "",
    });
    setOrder(newOrder);
  };

  // Function to handle recalculation when input field loses focus
  const handleRecalculate = (index, force = false) => {
    const updatedOrder = [...order];
    const currentRow = updatedOrder[index];

    if (!currentRow) {
      console.error(
        `handleRecalculate: Row at index ${index} is undefined`,
        updatedOrder
      );
      return;
    }

    // Check if deduction or addition has changed, unless forced
    const deductionValue = deduction.trigger ? deduction.val : null;
    const additionValue = addition.trigger ? addition.val : null;
    const prevDeduction = currentRow.deduction;
    const prevAddition = currentRow.addition;

    if (
      force ||
      deductionValue !== prevDeduction ||
      additionValue !== prevAddition
    ) {
      const recalculatedRow = getProductionData(
        orderDetails.productType,
        currentRow.width,
        currentRow.height,
        currentRow.control,
        currentRow.lift,
        currentRow.mount,
        currentRow.remark,
        currentRow.location,
        calculations[0],
        deductionValue,
        additionValue,
        currentRow.tile,
        matrix,
        currentRow.liftStyle
      );

      updatedOrder[index] = { ...currentRow, ...recalculatedRow };
      setOrder(updatedOrder);
    }
  };

  // New function to recalculate multiple rows
  const recalculateMultipleRows = (indices, currentOrder) => {
    let updatedOrder = [...currentOrder];
    indices.forEach((index) => {
      const currentRow = updatedOrder[index];
      if (!currentRow) {
        // console.error(`recalculateMultipleRows: Row at index ${index} is undefined`, updatedOrder);
        return;
      }
      const deductionValue = deduction.trigger ? deduction.val : null;
      const additionValue = addition.trigger ? addition.val : null;
      const recalculatedRow = getProductionData(
        orderDetails.productType,
        currentRow.width,
        currentRow.height,
        currentRow.control,
        currentRow.lift,
        currentRow.mount,
        currentRow.remark,
        currentRow.location,
        calculations[0],
        deductionValue,
        additionValue,
        currentRow.tile,
        matrix,
        currentRow.liftStyle
      );
      updatedOrder[index] = { ...currentRow, ...recalculatedRow };
      // console.log(`Recalculated row at index ${index}:`, updatedOrder[index]);
    });
    return updatedOrder;
  };

  const handleFocus = (row, field) => {
    // Trigger recalculation for the previously focused row if it exists
    if (
      focusedIndex &&
      (focusedIndex.row !== row || focusedIndex.field !== field)
    ) {
      handleRecalculate(focusedIndex.row);
    }

    // Set the new focused index
    setFocusedIndex({ row, field });

    if (field === "width" || field === "height") {
      if (window.matchMedia("(max-width: 1000px)").matches) {
        setIsKeyboardVisible(true);
        setActiveRowIndex(row);
      }
    } else {
      setIsKeyboardVisible(false);
    }
  };

  useEffect(() => {
    if (calculations[0]) {
      recalculateOrders(
        order,
        orderDetails.productType,
        calculations[0],
        setOrder,
        deduction.val,
        addition.val,
        matrix
      );
    }
  }, [calculations[0]]);

  //----- Submitting the order to the DB → 💽
  const handleSubmitOrder = async () => {
    // Split dealerName to get dealer information
    let dealerInfo = orderDetails.dealerName.split("_");
    const dealerId = dealerInfo[1];
    // Check if pricing exists
    const selectedDealer = getSelectedDealer(dealer, dealerId);

    if (!selectedDealer) {
      showSnackbar(
        "Dealer not found. Please select a valid dealer or refresh the page.",
        "error"
      );
      return;
    }

    if (orderDetails.productType !== "Materials") {
      const productType = orderDetails.productType;
      const validRate = checkProductRate(selectedDealer, productType);

      if (!validRate) {
        showSnackbar(
          `Pricing is missing or invalid for the selected product type (${productType}). Please update the product rates to proceed.`,
          "error"
        );
        setIsModalOpen(true);
        return;
      }

      const headrailId = orderDetails.headrail;
      const pricingExists = checkHeadrailPricing(
        selectedDealer,
        headrailId,
        productType
      );

      if (!pricingExists) {
        showSnackbar(
          `Pricing is missing for the selected product type (${productType}) and headrail. Please add pricing before submitting.`,
          "error"
        );
        setIsModalOpen(true);
        return;
      }
      const filteredOrder = order.filter((row) => {
        const hasWidth = row.width && row.width.trim() !== "";
        const hasHeight = row.height && row.height.trim() !== "";
        const hasLiftStyle = row.liftStyle && row.liftStyle.trim() !== "";

        if (hasWidth && hasHeight && !hasLiftStyle) {
          showSnackbar(
            "Please make sure all rows with width and height have a selected Lift Style!",
            "error"
          );
          return false;
        }

        return row.id !== -1 && hasWidth && hasHeight;
      });

      if (filteredOrder.length === 0) {
        showSnackbar(
          "No valid rows found for submission. Please check the input data.",
          "error"
        );
        return;
      }

      const invalidRows = filteredOrder.filter((row) => row.factor == null);

      if (invalidRows.length > 0) {
        showSnackbar(
          `${invalidRows.length} row(s) exceed size limits or have missing factor. Hover red rows for details.`,
          "warning"
        );

        const updatedOrder = order.map((row) => ({
          ...row,
          _isMatrixError: row.factor == null,
        }));
        setOrder(updatedOrder);

        setTimeout(() => {
          const firstError = document.querySelector(
            'tr[data-matrix-error="true"]'
          );
          firstError?.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 100);

        return;
      }

      orderDetails.order = filteredOrder.map(
        ({ error, _isMatrixError, ...clean }) => clean
      );
    }

    const val = {
      dealerName: dealerInfo[0],
      dealerId: dealerInfo[1],
      productTag: orderDetails.productTag,
      productType: orderDetails.productType,
      productMaterial: orderDetails.productMaterial,
      liftStyle: orderDetails.liftStyle,
      orderRemark: orderDetails.orderRemark,
      order: orderDetails.order,
      orderFactor,
      headrail: orderDetails.headrail,
      sleeveOption,
      selectedMaterialId,
      materialOrders,
    };

    try {
      await dispatch(createDealerOrderAction(val, userInfo.token));
      showSnackbar("Order submitted successfully!", "success");
    } catch (error) {
      showSnackbar(
        "There was an error submitting the order. Please try again.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (!userInfo) {
      navigate("/sign-in");
    }
    window.scrollTo(0, 0);
    toggleFullScreen((nav = { nav }));
  }, [userInfo, navigate]);

  useEffect(() => {
    // window.scrollTo(0, document.body.scrollHeight);
    const validOrders = order.filter(({ factor, width, height }) => {
      return !isNaN(factor) && Number(factor) > 0 && width && height;
    });

    const totalFactor = validOrders.reduce((total, { factor = 0 }) => {
      return total + (isNaN(factor) ? 0 : Number(factor));
    }, 0);

    setOrderFactor(totalFactor);
  }, [order]);

  useEffect(() => {
    dispatch(ListDealerAction(userInfo.token));
  }, []);

  useEffect(() => {
    let dealer = orderDetails.dealerName.split("_");
    if (data) {
      fileDownload(
        data,
        `${dealer[0]}-${orderDetails.productType}-${orderDetails.productTag}.pdf`
      );
    }
  }, [data]);

  const renderHeadrailOptions = (productType) => {
    if (!items) return null;

    return items.map((item, index) => {
      if (productType && !item.proDependency.includes(productType)) {
        return null;
      }
      return (
        <option key={index} value={item.id}>
          {item.name}
        </option>
      );
    });
  };

  const deleteRow = (index) => {
    const newOrder = order.filter((_, i) => i !== index);
    setOrder(newOrder);
  };

  useEffect(() => {
    if (focusedIndex !== null && inputRefs.current[focusedIndex.row]) {
      const input = inputRefs.current[focusedIndex.row][focusedIndex.field];
      if (input) {
        input.focus();
        input.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [focusedIndex]);

  useEffect(() => {
    if (userInfo?.token && orderDetails.productType) {
      if (orderDetails.productType === "Materials" && category) {
        dispatch(getAllInventoryItems(userInfo.token, category));
      } else {
        dispatch(
          getInvItemsByCat("Headrail", userInfo.token, orderDetails.productType)
        );
      }
      dispatch(
        getFabricItems("Fabric", userInfo.token, orderDetails.productType)
      );
      dispatch(
        getLiftStyleItems(
          "Lift_hardware,Motor",
          userInfo.token,
          orderDetails.productType
        )
      );
      dispatch(
        fetchMatrixByProductType(orderDetails.productType, userInfo.token)
      );
    }
  }, [
    userInfo.token,
    dispatch,
    orderDetails.productType,
    inventoryCreateSuccess,
    category,
  ]);

  const handleSleeveChange = (e) => {
    setSleeveOption(e.target.value);
  };

  const fabricMapping = Fabrics.reduce((acc, fabric) => {
    acc[fabric.id] = fabric.name;
    return acc;
  }, {});

  const handleAdditionClick = () => {
    setShowAdditionInput(true);
    setShowDeductionInput(false);
  };

  const handleDeductionClick = () => {
    setShowDeductionInput(true);
    setShowAdditionInput(false);
  };

  const handleCancel = () => {
    setShowAdditionInput(false);
    setShowDeductionInput(false);
    // Reset the deduction and addition values
    setAddition({ val: null, trigger: false });
    setDeduction({ val: null, trigger: false });
  };
  const handleFractionChange = (e) => {
    const value = e.target.value;
    if (showDeductionInput) {
      setDeduction({ val: value, trigger: true });
    } else if (showAdditionInput) {
      setAddition({ val: value, trigger: true });
    }
  };

  const renderMaterialOptions = () => {
    if (!inventoryData || !Array.isArray(inventoryData)) {
      return null;
    }

    return inventoryData.map((item) => (
      <option key={item._id} value={item._id}>
        {item.name}
      </option>
    ));
  };

  const handleAddMaterialOrder = (index, field, value) => {
    const updatedOrders = [...materialOrders];

    // If the index is valid, update the specific order
    if (index !== null) {
      updatedOrders[index] = {
        ...updatedOrders[index],
        [field]: value,
      };
    } else {
      // Add a new order if index is null
      updatedOrders.push({
        category: "",
        material: "",
        customCost: "",
        quantity: 1,
      });
    }

    setMaterialOrders(updatedOrders);
  };

  const handleRemoveMaterialOrder = (index) => {
    setMaterialOrders(materialOrders.filter((_, i) => i !== index));
  };

  const handleNavigateToPricing = () => {
    let dealerInfo = orderDetails.dealerName.split("_");
    const dealerId = dealerInfo[1];
    navigate(`/dealer/edit-product-rate/${dealerId}`);
  };

  return (
    <>
      {loadingCreateOrder ? (
        <Loader />
      ) : (
        <>
          {successOrder ? (
            <Badge
              p={{
                type: "success",
                message: "New Order has been made 🙂",
                redirectName: "Click here to submit another order",
                redirect: "/order/add-order",
                refresh: true,
              }}
            />
          ) : (
            <>
              <div className="row mt-5 mb-4">
                <div className="row">
                  <div className="col-lg-10">
                    <h6 className="mb-2 text-uppercase">Order Info</h6>
                  </div>

                  <div className="col-lg-2">
                    <div className="form-group">
                      {orderDetails.dealerName && orderDetails.productType ? (
                        <button
                          className="btn btn-success w-100"
                          type="submit"
                          onClick={handleSubmitOrder}
                        >
                          Submit the Order
                        </button>
                      ) : (
                        <button
                          className="btn btn-light w-100"
                          type="submit"
                          disabled
                        >
                          Submit the Order
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Flex container for button + input settings */}
                <div className="d-flex justify-content-end align-items-center gap-3">
                  <AIImgToOrderButton />

                  <div className="d-flex align-items-center">
                    <InputSettingsDropdown
                      handleSettingsClick={handleSettingsClick}
                      handleAdditionClick={handleAdditionClick}
                      handleDeductionClick={handleDeductionClick}
                      showSettingsModal={showSettingsModal}
                      handleCloseModal={handleCloseModal}
                      setOrder={setOrder}
                      order={order}
                    />
                  </div>
                </div>

                {/* Order Headrail, Material, Fabric Selecting Form */}
                {!loadingClient ? (
                  <>
                    <OrderDetailsForm
                      orderDetails={orderDetails}
                      dealer={dealer}
                      handleChange={handleChange}
                      productTypeOptions={productTypes}
                      renderHeadrailOptions={renderHeadrailOptions}
                      showCustomFabricModal={showCustomFabricModal}
                      setShowCustomFabricModal={setShowCustomFabricModal}
                      headrailConfig={headrailConfig}
                      sleeveOption={sleeveOption}
                      handleSleeveChange={handleSleeveChange}
                      Fabrics={Fabrics}
                      LiftStyle={LiftStyle}
                      showCustomLiftStyleModal={showCustomLiftStyleModal}
                      setShowCustomLiftStyleModal={setShowCustomLiftStyleModal}
                    />
                  </>
                ) : (
                  <Loader />
                )}
              </div>

              {orderDetails.productType === "Materials" && (
                <MaterialOrdersTable
                  materialOrders={materialOrders}
                  handleAddMaterialOrder={handleAddMaterialOrder}
                  handleRemoveMaterialOrder={handleRemoveMaterialOrder}
                  showAddMaterialModal={showAddMaterialModal}
                  setShowAddMaterialModal={setShowAddMaterialModal}
                  renderMaterialOptions={renderMaterialOptions}
                  dealer={orderDetails?.dealerName}
                  setMaterialOrders={setMaterialOrders}
                />
              )}
              {errToggle.type && <Badge p={errToggle} />}
              <hr />
              {orderDetails.productType !== "Materials" && (
                <>
                  <h6 className="mb-0 text-uppercase">Order Overview </h6>
                  <OrderOverviewUI
                    productType={orderDetails.productType}
                    orderFactor={orderFactor}
                    productMaterial={
                      fabricMapping[orderDetails?.productMaterial] || "N/A"
                    } // Use mapping to get the name
                  />
                </>
              )}

              {/*--------- Adding the product parameters➕ ---------- */}
              {orderDetails.productType && (
                <>
                  <h6 className="mb-0 text-uppercase mb-2">Add Product</h6>
                  {deduction.val && (
                    <NotificationBadge
                      colour="success"
                      icon={<ContentCutIcon />}
                      value={deduction.val}
                      message1="A deduction of"
                      message2="is applying to the width"
                    />
                  )}
                  {addition.val && (
                    <NotificationBadge
                      colour="success"
                      icon={<AddIcon />}
                      value={addition.val}
                      message1="An addition of"
                      message2="is applying to the width"
                    />
                  )}
                  {insertion.val && (
                    <NotificationBadge
                      colour="warning"
                      icon={<SubdirectoryArrowRightIcon />}
                      value={insertion.val}
                      message1="Inserting the values to the index"
                      message2="is active"
                    />
                  )}
                  <div>
                    {/* Render additional input for fraction when needed */}
                    {(showAdditionInput || showDeductionInput) && (
                      <div className="mt-3">
                        <input
                          type="text"
                          value={
                            showDeductionInput ? deduction.val : addition.val
                          }
                          onChange={handleFractionChange}
                          placeholder="Enter fraction (e.g., 1/8)"
                          className="form-control"
                          style={{ width: "150px", display: "inline-block" }}
                        />
                        <button
                          className="btn btn-danger"
                          onClick={handleCancel}
                          style={{ marginLeft: "10px" }}
                        >
                          Cancel
                        </button>
                      </div>
                    )}
                    {orderDetails.productType !== "Materials" && (
                      <>
                        {loading && (
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            my={2}
                          >
                            <CircularProgress />
                          </Box>
                        )}
                        {!loading && error && (
                          <Alert severity="error" variant="outlined">
                            {error}
                          </Alert>
                        )}

                        <div className="container-fluid">
                          <div className="table-card-container">
                            <div
                              className="table-responsive"
                              style={{ overflowX: "auto" }}
                              ref={tableContainerRef}
                            >
                              <table className="table table-bordered table-sm table-border-custom">
                                <InputTableHeader
                                  settingsData={settingsData}
                                  headrailConfig={calculations[0]}
                                  order={order}
                                />
                                <TableInputs
                                  order={order}
                                  setOrder={setOrder}
                                  handleInputChange={handleInputChange}
                                  addRow={addRow}
                                  deleteRow={deleteRow}
                                  onFocus={handleFocus}
                                  inputRefs={inputRefs}
                                  isReadOnly={isReadOnly}
                                  settingsData={settingsData}
                                  headrailConfig={calculations[0]}
                                  handleRecalculate={handleRecalculate}
                                  LiftStyle={LiftStyle}
                                  Motor={Motor}
                                  recalculateMultipleRows={
                                    recalculateMultipleRows
                                  }
                                />
                              </table>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  {isKeyboardVisible && (
                    <div
                      style={{
                        width: "100%",
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      <CustomKeyboard
                        onKeyPress={handleKeyPress}
                        onNext={handleNext}
                        onPrevious={handlePrevious}
                        onEnter={handleEnter}
                        onClear={handleClear}
                        onClose={handleCloseKeyboard}
                        handleRecalculate={handleRecalculate}
                        activeRowIndex={activeRowIndex}
                      />
                    </div>
                  )}
                  <hr />
                </>
              )}

              <PricingModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onNavigate={handleNavigateToPricing}
              />
            </>
          )}
          <SnackbarComponent />

          <div className="d-md-none" style={{ height: "30vh" }}></div>

          <br />
          <br />
        </>
      )}
    </>
  );
};

export default OrderCreate;
